import React from 'react';
import { Delete } from '@icons/common';
import { RadioButton } from '@components/RadioButton';
import classNames from 'classnames';
import './QuoteItem.scss';

interface QuoteItemProps {
  itemImage: string;
  itemName: string;
  itemDescription?: string;
  buttonType: string;
  className?: string;
  onSelect?: (itemName: string) => void;
  onButtonClick?: (itemName: string) => void;
}

export const QuoteItem = ({
  itemImage,
  itemName,
  itemDescription,
  buttonType,
  className,
  onSelect,
  onButtonClick = () => {},
}: QuoteItemProps) => {
  const renderButtonComponent = () => {
    switch (buttonType) {
      case 'delete':
        return <Delete />;
      case 'radio':
        return <RadioButton id='quote_radio' name='quote_item' />;
      default:
        return null;
    }
  };

  return (
    <label
      className={classNames(`quote-item ${className}`)}
      onClick={() => onSelect && onSelect(itemName)}
    >
      <div className='quote-image-container'>
        <img loading='lazy' src={itemImage} alt={itemName} />
      </div>

      <div className='quote-item-text'>
        <div className='title'>{itemName}</div>
        {itemDescription && <p className='description'>{itemDescription}</p>}
      </div>
      <div className='quote-item-button' onClick={() => onButtonClick(itemName)}>
        {renderButtonComponent()}
      </div>
    </label>
  );
};
